module.exports = __webpack_public_path__ + "static/media/resume.bb87d955.pdf";